/* Sindhu Reddy — flagship homepage sections: tabs, quick view, featured piece, lookbook, reveals.
   Add to bag uses the theme's own <add-to-cart> element, so the cart drawer behaves as usual. */
(() => {
  if (window.srHome) return;
  window.srHome = true;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ICON_CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>';
  const ICON_NEEDLE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20 18.5 5.5a1.6 1.6 0 0 1 2.3 2.3L6.3 22.3" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><path d="M3 21c2-4 6-3 7-7" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';

  /* money in the store's own format */
  function money(cents) {
    const fmt = ((window.theme && theme.shopSettings && theme.shopSettings.moneyFormat) || '₹{{amount_no_decimals}}').replace(/<[^>]*>/g, '');
    const n = cents / 100;
    const whole = Math.round(n) === n;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k.indexOf('no_decimals') > -1 || whole) return Math.round(n).toLocaleString('en-IN');
      return n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }
  const sized = (url, w) => (url.startsWith('//') ? 'https:' + url : url) + (url.includes('?') ? '&' : '?') + 'width=' + w;
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
  function initReveals(root = document) { $$('.srh-reveal:not(.is-in)', root).forEach(el => (io ? io.observe(el) : el.classList.add('is-in'))); }

  /* ---------- tabs ---------- */
  function initTabs(root = document) {
    $$('[data-srh-tabs]', root).forEach(wrap => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const btns = $$('.srh-tabs__btn', wrap);
      const open = (btn, focus) => {
        btns.forEach(b => {
          const on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', String(on));
          b.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) btn.focus();
      };
      btns.forEach((b, i) => {
        b.addEventListener('click', () => open(b));
        b.addEventListener('keydown', e => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          open(btns[(i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length], true);
        });
      });
    });
  }

  /* ---------- size radios -> theme <add-to-cart> ---------- */
  function wireSizes(scope, btn) {
    scope.addEventListener('change', e => {
      if (!e.target.matches('input[type=radio]')) return;
      btn.dataset.variantId = e.target.value;
      btn.textContent = btn.dataset.label || 'Add to bag';
      btn.classList.remove('is-disabled');
      btn.removeAttribute('aria-disabled');
    });
    btn.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); } });
  }

  /* ---------- featured piece ---------- */
  function initFeatured(root = document) {
    $$('[data-srh-feat]', root).forEach(sec => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      const main = $('.srh-feat__main img', sec);
      $$('.srh-feat__thumb', sec).forEach(t => t.addEventListener('click', () => {
        $$('.srh-feat__thumb', sec).forEach(x => x.classList.toggle('is-active', x === t));
        if (!main) return;
        main.style.opacity = 0;
        setTimeout(() => { main.removeAttribute('srcset'); main.src = t.dataset.src; main.onload = () => { main.style.opacity = 1; }; }, 180);
      }));
      const btn = $('add-to-cart', sec);
      if (btn) wireSizes(sec, btn);
    });
  }

  /* ---------- quick view ---------- */
  let qv = null, lastFocus = null;
  function buildQV() {
    qv = document.createElement('div');
    qv.className = 'srh-qv';
    qv.hidden = true;
    qv.setAttribute('role', 'dialog');
    qv.setAttribute('aria-modal', 'true');
    qv.setAttribute('aria-labelledby', 'srh-qv-title');
    qv.innerHTML = `
      <div class="srh-qv__backdrop" data-srh-close></div>
      <div class="srh-qv__panel">
        <button class="srh-qv__close" type="button" aria-label="Close quick view" data-srh-close>${ICON_CLOSE}</button>
        <div class="srh-qv__gallery"><div class="srh-qv__main"><img alt=""></div><div class="srh-qv__thumbs"></div></div>
        <div class="srh-qv__info">
          <p class="srh-qv__kicker">Sindhu Reddy</p>
          <h2 class="srh-qv__title" id="srh-qv-title"></h2>
          <p class="srh-qv__price"></p>
          <p class="srh-qv__desc"></p>
          <p class="srh-qv__details"></p>
          <fieldset class="srh-sizes"><legend><span>Select size</span><a href="/pages/size-chart">Size chart</a></legend><div class="srh-sizepicks"></div></fieldset>
          <add-to-cart class="srh-btn is-disabled" data-variant-id="" data-label="Add to bag" role="button" tabindex="0" aria-disabled="true">Select a size</add-to-cart>
          <p class="srh-qv__msg" role="status" aria-live="polite"></p>
          <a class="srh-more" href="#">View full details</a>
          <p class="srh-qv__note">${ICON_NEEDLE}<span>Made to order · delivered in 20–25 days</span></p>
        </div>
      </div>`;
    document.body.appendChild(qv);
    wireSizes($('.srh-sizes', qv), $('add-to-cart', qv));
    qv.addEventListener('click', e => {
      if (e.target.closest('[data-srh-close]')) closeQV();
      const t = e.target.closest('.srh-qv__thumbs button');
      if (t) { $$('.srh-qv__thumbs button', qv).forEach(x => x.classList.toggle('is-active', x === t)); $('.srh-qv__main img', qv).src = t.dataset.src; }
    });
  }
  async function openQV(handle) {
    if (!qv) buildQV();
    lastFocus = document.activeElement;
    let p;
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      p = await (await fetch(`${root}products/${handle}.js`)).json();
    } catch (err) { window.location.href = `/products/${handle}`; return; }
    const v0 = p.variants[0];
    const cmp = p.compare_at_price > p.price ? p.compare_at_price : 0;
    $('.srh-qv__title', qv).textContent = p.title;
    $('.srh-qv__price', qv).innerHTML = money(p.price) + (cmp ? ` <s>${money(cmp)}</s> <em>${Math.floor((cmp - p.price) * 100 / cmp)}% off</em>` : '');
    const tmp = document.createElement('div');
    tmp.innerHTML = p.description || '';
    const text = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
    const mi = text.search(/\bMaterial\b/);
    let story = mi > -1 ? text.slice(0, mi) : text;
    let details = mi > -1 ? text.slice(mi) : '';
    const stop = details.search(/\b(Size Guide|Shipping|Disclaimer|Note:|Please note)\b/);
    if (stop > -1) details = details.slice(0, stop);
    if (story.length > 320) story = story.slice(0, 320).replace(/\s\S*$/, '') + '…';
    $('.srh-qv__desc', qv).textContent = story;
    $('.srh-qv__details', qv).textContent = details.replace(/[\s.;,-]+$/, '');
    $('.srh-more', qv).href = p.url || `/products/${handle}`;
    const imgs = (p.images || []).slice(0, 6);
    const main = $('.srh-qv__main img', qv);
    main.src = imgs[0] ? sized(imgs[0], 1000) : '';
    main.alt = p.title;
    $('.srh-qv__thumbs', qv).innerHTML = imgs.map((src, k) => `<button type="button" class="${k ? '' : 'is-active'}" data-src="${sized(src, 1000)}" aria-label="Photo ${k + 1}"><img src="${sized(src, 160)}" alt=""></button>`).join('');
    const btn = $('add-to-cart', qv);
    const sizes = $('.srh-sizes', qv);
    $('.srh-qv__msg', qv).textContent = '';
    btn.dataset.variantId = '';
    btn.classList.add('is-disabled');
    btn.setAttribute('aria-disabled', 'true');
    if (p.variants.length === 1 && v0.title === 'Default Title') {
      sizes.hidden = true;
      if (v0.available) { btn.dataset.variantId = String(v0.id); btn.textContent = 'Add to bag'; btn.classList.remove('is-disabled'); btn.removeAttribute('aria-disabled'); }
      else btn.textContent = 'Sold out';
    } else {
      sizes.hidden = false;
      $('.srh-sizepicks', qv).innerHTML = p.variants.map(v => `<label class="srh-sizepick${v.available ? '' : ' is-out'}"><input type="radio" name="srh-qv-size" value="${v.id}"${v.available ? '' : ' disabled'}><span>${esc(v.title)}</span></label>`).join('');
      btn.textContent = p.available ? 'Select a size' : 'Sold out';
    }
    qv.hidden = false;
    document.body.classList.add('srh-qv-open');
    $('.srh-qv__close', qv).focus();
  }
  function closeQV() {
    if (!qv || qv.hidden) return;
    qv.hidden = true;
    document.body.classList.remove('srh-qv-open');
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-srh-qv]');
    if (b) { e.preventDefault(); openQV(b.dataset.srhQv); }
  });
  document.addEventListener('keydown', e => {
    if (!qv || qv.hidden) return;
    if (e.key === 'Escape') closeQV();
    if (e.key === 'Tab') {
      const f = $$('button, a[href], input:not([disabled]), add-to-cart', qv).filter(el => el.offsetParent);
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  document.addEventListener('ajaxProduct:added', () => closeQV());
  document.addEventListener('ajaxProduct:error', e => { if (qv && !qv.hidden) $('.srh-qv__msg', qv).textContent = (e.detail && e.detail.errorMessage) || 'Sorry, this size could not be added.'; });

  /* ---------- lookbook: arrows + drag ---------- */
  function initLookbook(root = document) {
    $$('[data-srh-lookbook]', root).forEach(sec => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      const track = $('.srh-lookbook__track', sec);
      const prev = $('.srh-arrow--prev', sec);
      const next = $('.srh-arrow--next', sec);
      const update = () => { if (!prev) return; prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft > track.scrollWidth - track.clientWidth - 4; };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .8, behavior: reduce ? 'auto' : 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .8, behavior: reduce ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* ---------- sliding rows: fingers scroll natively; add mouse drag, a progress line and autoplay ---------- */
  const SLIDERS = '.srh-arches__row, .srh-occ__row, .srh-lookbook__track, .srh-tabs__list';
  function initSliders(root = document) {
    $$(SLIDERS, root).forEach(track => {
      if (track.dataset.slider) return;
      track.dataset.slider = '1';
      let bar = null;
      if (!track.classList.contains('srh-tabs__list')) {
        bar = document.createElement('div');
        bar.className = 'srh-progress';
        bar.setAttribute('aria-hidden', 'true');
        bar.innerHTML = '<i></i>';
        track.after(bar);
      }
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        track.classList.toggle('is-scrollable', max > 4);
        if (!bar) return;
        bar.hidden = max <= 4;
        if (max <= 4) return;
        const vis = track.clientWidth / track.scrollWidth;
        bar.firstChild.style.width = (vis * 100) + '%';
        bar.firstChild.style.transform = `translateX(${(track.scrollLeft / max) * (1 / vis - 1) * 100}%)`;
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      // left edge of every card, in scroll coordinates
      const stops = () => {
        const pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
        const base = track.getBoundingClientRect().left - track.scrollLeft;
        return [...track.children].map(ch => Math.round(ch.getBoundingClientRect().left - base - pad));
      };

      let down = false, sx = 0, sl = 0, dx = 0, moved = false;
      track.addEventListener('dragstart', e => e.preventDefault());
      track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || track.scrollWidth - track.clientWidth <= 4) return;
        down = true; moved = false; dx = 0; sx = e.clientX; sl = track.scrollLeft;
      });
      window.addEventListener('pointermove', e => {
        if (!down) return;
        dx = e.clientX - sx;
        if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); }
        if (moved) track.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!down) return;
        down = false;
        if (!moved) return;
        // settle on the next / previous card in the drag direction
        const s = stops();
        const cur = track.scrollLeft;
        let to = dx < 0 ? s.find(v => v > cur + 2) : s.slice().reverse().find(v => v < cur - 2);
        if (to === undefined) to = dx < 0 ? track.scrollWidth : 0;
        track.scrollTo({ left: to, behavior: reduce ? 'auto' : 'smooth' });
        setTimeout(() => track.classList.remove('is-dragging'), reduce ? 0 : 450);
        setTimeout(() => { moved = false; }, 0);
      });
      // a drag must not also open the link under the cursor
      track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

      /* autoplay: one card every few seconds while the row is on screen.
         Touch, swipe, wheel, hover or drag pauses it; it picks up again after a short rest. */
      if (bar && !reduce && track.dataset.autoplay !== 'false') {
        let visible = false, hover = false, last = 0;
        const hold = () => { last = Date.now(); };
        ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach(ev => track.addEventListener(ev, hold, { passive: true }));
        track.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hover = true; });
        track.addEventListener('pointerleave', () => { if (hover) { hover = false; hold(); } });
        new IntersectionObserver(es => { visible = es[0].isIntersecting; }, { threshold: .5 }).observe(track);
        const timer = setInterval(() => {
          if (!track.isConnected) return clearInterval(timer);
          if (!visible || hover || down || document.hidden || Date.now() - last < 5000) return;
          const max = track.scrollWidth - track.clientWidth;
          if (max <= 4) return;
          const cur = track.scrollLeft;
          let to = stops().find(v => v > cur + 2);
          if (to === undefined || cur >= max - 2) to = 0;
          track.scrollTo({ left: Math.min(to, max), behavior: 'smooth' });
        }, parseInt(track.dataset.autoplay, 10) || 3500);
      }
    });
  }

  function initAll(root) { initReveals(root); initTabs(root); initFeatured(root); initLookbook(root); initSliders(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  // theme editor: re-init a section after it is edited
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  document.addEventListener('shopify:block:select', e => {
    const btn = e.target.closest && e.target.closest('.srh-tabs__btn');
    const panel = e.target.closest && e.target.closest('.srh-tabs__panel');
    if (panel) { const b = document.querySelector(`[aria-controls="${panel.id}"]`); b && b.click(); }
    else if (btn) btn.click();
  });
})();
